<div id="continuesLater" class="header container">
  <div class="row title-row">
    <div class="col-12">
      @if (this.DataService.connectionLinkType !== 'PARTNERI') {
        <h1 class="text-center fw-bold text-uppercase mb-0">{{ 'continuesLater.title-1' | translate }}</h1>
        <h3 class="text-center m-0 text-uppercase">{{ 'continuesLater.title-2' | translate }}</h3>
      }
      @if (this.DataService.connectionLinkType === 'PARTNERI') {
        <h1 class="text-center fw-bold text-uppercase mb-0">{{this._contractorName}}</h1>
        <h3 class="text-center m-0 text-uppercase">{{ 'continuesLater.title-3' | translate }}</h3>
      }

      <p class="text-center pt-5" [innerHTML]="'continuesLater.feedback' | translate"></p>
    </div>
  </div>
</div>
